// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ItemDetail } from './item-detail';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ItemBin extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static UnitecDefault = 100002;
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(30) */
  name!: string;
  /** Binary */
  rowVersion!: any;
  /** Inv FK itemBinId */
  itemDetails!: ItemDetail[];
}

